/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewkpiviews2Inputs */

const en_overviewkpiviews2 = /** @type {(inputs: Overviewkpiviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Views, 30 days`)
};

const de_overviewkpiviews2 = /** @type {(inputs: Overviewkpiviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrufe, 30 Tage`)
};

/**
* | output |
* | --- |
* | "Views, 30 days" |
*
* @param {Overviewkpiviews2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewkpiviews2 = /** @type {((inputs?: Overviewkpiviews2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewkpiviews2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewkpiviews2(inputs)
	return de_overviewkpiviews2(inputs)
});
export { overviewkpiviews2 as "overviewKpiViews" }